import {
  Flex,
  Box,
  Divider,
  IconButton,
  CloseIcon,
  ReorderIcon,
} from '@frontend/components';

import { useSortableItem } from 'components/sortableListProvider';

import { WorkflowStep } from './types';

export const StepName = ({ name }: { name: string }) => (
  <Box
    fontSize="md"
    textAlign="left"
    wordBreak="break-word"
    paddingInline={0.5}
    paddingBlock={0.75}
  >
    {name}
  </Box>
);

type SortableWorkflowStepsListItemProps = {
  index: number;
  workflowStep: WorkflowStep | undefined;
  onRemove: (index: number) => void;
};

export const SortableWorkflowStepsListItem = ({
  index,
  workflowStep,
  onRemove,
}: SortableWorkflowStepsListItemProps) => {
  const { sortRef, sortHandleRef } = useSortableItem({
    itemType: 'customColumn',
    initialIndex: index,
  });

  return (
    <Box
      as="li"
      alignItems="center"
      background="page.surface"
      border="1px solid"
      borderColor="separator.divider"
      color="feature.primary"
      display="flex"
      justifyContent="space-between"
      marginTop="-1px"
      paddingY={0}
      paddingX={1}
      zIndex="1001"
      minHeight={4}
      ref={sortRef}
    >
      <Flex flex={1} ref={sortHandleRef}>
        <Box p={0.5} cursor="grab" color="feature.secondary">
          <ReorderIcon size={2.5} />
        </Box>
        <StepName name={workflowStep?.name || '--'} />
      </Flex>
      <Divider height="1rem" mr={1} orientation="vertical" />
      <IconButton size="sm" onClick={() => onRemove(index)}>
        <CloseIcon />
      </IconButton>
    </Box>
  );
};
